export default __webpack_public_path__ + "static/dei-resolution-template-b5537aa424dcb3c47442d117ae7b5344.pdf";